import ReferralAccessModal from "./ReferralAccessModal";

export default ReferralAccessModal;
